import { Alert, Box } from '@mui/material'
import CreateWorkspaceCard from './CreateWorkspaceCard.jsx'
import { useCreateWorkspace } from '@/hooks/useCreateWorkspace'
import { createWorkspaceErrorMessage } from '@/hooks/createWorkspaceErrorMessage'
import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspacePage() {
  const { form, submit, onSubmit } = useCreateWorkspace({ switchOnSuccess: true })
  const errorMessage =
    form.submitError || (submit.isError ? createWorkspaceErrorMessage(submit.error) : '')
  return (
    <Box className={styles.page}>
      {errorMessage ? (
        <Alert severity="error" className={styles.error}>{errorMessage}</Alert>
      ) : null}
      <CreateWorkspaceCard
        form={form}
        onSubmit={onSubmit}
        submitLabel={submit.isPending ? 'Creating…' : 'Create workspace'}
      />
    </Box>
  )
}
